import React, { Component } from "react";
import { Route, Switch, HashRouter, Redirect } from "react-router-dom";
import "./App.css";
import * as serviceWorker from "./serviceWorker";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import InventoriesList from "./components/InventoriesList";
import Login from "./components/Login";
import ListDetails from "./components/ListDetails";
import ViewCheck from "./components/ViewCheck";
import NewCheck from "./components/NewCheck";
import FindList from "./components/FindList";
import Settings from "./components/Settings";

const theme = createMuiTheme({
    palette: {
        primary: { main: "#43A047", contrastText: "#ffffff" },
        secondary: { main: "#66BB6A", contrastText: "#000000" }
    },
    typography: {
        useNextVariants: true
    }
});

class App extends Component {
    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <HashRouter>
                    <Switch>
                        <Route exact path="/" component={InventoriesList} />
                        <Route exact path="/login" component={Login} />
                        <Route exact path="/list/:id" component={ListDetails} />
                        <Route exact path="/check/view/:id" component={ViewCheck} />
                        <Route exact path="/check/new/:id" component={NewCheck} />
                        <Route exact path="/find/:id" component={FindList} />
                        <Route exact path="/settings" component={Settings} />
                        <Redirect to="/" />
                    </Switch>
                </HashRouter>
            </MuiThemeProvider>
        );
    }
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

export default App;
